/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Messaging_Bots_Execute_Detail7Inputs */

const en_svc_messaging_bots_execute_detail7 = /** @type {(inputs: Svc_Messaging_Bots_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build against real numbers, test templates and payments.`)
};

const ar_svc_messaging_bots_execute_detail7 = /** @type {(inputs: Svc_Messaging_Bots_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البناء على أرقام حقيقية، واختبار القوالب والمدفوعات.`)
};

const bn_svc_messaging_bots_execute_detail7 = /** @type {(inputs: Svc_Messaging_Bots_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আসল নম্বরে তৈরি, টেমপ্লেট আর পেমেন্ট পরীক্ষা।`)
};

const de_svc_messaging_bots_execute_detail7 = /** @type {(inputs: Svc_Messaging_Bots_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwicklung auf Basis echter Nummern, Tests für Vorlagen und Zahlungen.`)
};

const es_svc_messaging_bots_execute_detail7 = /** @type {(inputs: Svc_Messaging_Bots_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarrollo con números reales, pruebas de plantillas y pagos.`)
};

const fr_svc_messaging_bots_execute_detail7 = /** @type {(inputs: Svc_Messaging_Bots_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partez de vrais numéros, tests des templates et des paiements.`)
};

const pt_svc_messaging_bots_execute_detail7 = /** @type {(inputs: Svc_Messaging_Bots_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenvolva a partir de números reais, testes de templates e pagamentos.`)
};

const zh_svc_messaging_bots_execute_detail7 = /** @type {(inputs: Svc_Messaging_Bots_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用真实号码开发，测试模板和支付。`)
};

const tr_svc_messaging_bots_execute_detail7 = /** @type {(inputs: Svc_Messaging_Bots_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerçek numaralarla geliştirme, şablon ve ödeme testleri.`)
};

const ru_svc_messaging_bots_execute_detail7 = /** @type {(inputs: Svc_Messaging_Bots_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Работайте на реальных номерах, тесты темплейтов и платежей.`)
};

const pl_svc_messaging_bots_execute_detail7 = /** @type {(inputs: Svc_Messaging_Bots_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prawdziwe numery, nie mocki, testy templatek i płatności.`)
};

/**
* | output |
* | --- |
* | "Build against real numbers, test templates and payments." |
*
* @param {Svc_Messaging_Bots_Execute_Detail7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_messaging_bots_execute_detail7 = /** @type {((inputs?: Svc_Messaging_Bots_Execute_Detail7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Messaging_Bots_Execute_Detail7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_messaging_bots_execute_detail7(inputs)
	if (locale === "bn") return bn_svc_messaging_bots_execute_detail7(inputs)
	if (locale === "de") return de_svc_messaging_bots_execute_detail7(inputs)
	if (locale === "es") return es_svc_messaging_bots_execute_detail7(inputs)
	if (locale === "fr") return fr_svc_messaging_bots_execute_detail7(inputs)
	if (locale === "pt") return pt_svc_messaging_bots_execute_detail7(inputs)
	if (locale === "zh") return zh_svc_messaging_bots_execute_detail7(inputs)
	if (locale === "tr") return tr_svc_messaging_bots_execute_detail7(inputs)
	if (locale === "ru") return ru_svc_messaging_bots_execute_detail7(inputs)
	if (locale === "pl") return pl_svc_messaging_bots_execute_detail7(inputs)
	return en_svc_messaging_bots_execute_detail7(inputs)
});
export { svc_messaging_bots_execute_detail7 as "svc_messaging-bots_EXECUTE_detail" }